import { useState } from 'react'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  thinking: string
  isStreaming?: boolean
}

/**
 * Collapsible extended-thinking block (deep mode only). Streams open-able while
 * the model thinks; collapses to a one-line summary. Mirrors the concierge
 * thinking block's restraint — small uppercase label + amber pulse dot.
 */
export function StewardThinkingBlock({ thinking, isStreaming = false }: Props) {
  const [expanded, setExpanded] = useState(false)
  const hasContent = thinking.trim().length > 0

  if (!hasContent && !isStreaming) return null

  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-2 text-[10px] font-light uppercase tracking-[0.08em] text-muted-foreground transition-colors hover:text-foreground"
      >
        <ChevronRight
          size={10}
          className={cn('transition-transform duration-200', expanded && 'rotate-90')}
        />
        <span
          className={cn(
            'inline-block h-1.5 w-1.5 rounded-full',
            isStreaming ? 'animate-pulse bg-amber-500' : 'bg-muted-foreground/40'
          )}
        />
        <span>{isStreaming ? 'Thinking…' : 'Thought'}</span>
      </button>
      {expanded && hasContent && (
        <div className="mt-2 whitespace-pre-wrap border-l border-border/60 pl-4 text-[12px] font-light leading-relaxed text-muted-foreground">
          {thinking.trim()}
        </div>
      )}
    </div>
  )
}
